import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ReporteDetalleSaldosComponent } from '../../shared/components/reporte-detalle-saldos/reporte-detalle-saldos.component';
import { Chart, ChartConfiguration, ChartType, registerables } from 'chart.js';
import { ImportsModule } from "../../shared/imports.module";
import { Colaborador, Usuario } from '../../shared/models';
import { HomeService } from '../../shared/services/home.service';
import { finalize, pipe, Subject, takeUntil } from 'rxjs';
import saveAs from 'file-saver';
import { ReportesService } from '../../shared/services/reportes.service';
import { PerfilStore } from '../../shared/store/perfil.store';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, FormsModule, NzDescriptionsModule, NzIconModule, NzTableModule, NzInputModule, NzButtonModule, ReporteDetalleSaldosComponent, ImportsModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {

  constructor(private homeService: HomeService, private reportesService: ReportesService, private cdr: ChangeDetectorRef, private sessionStore: PerfilStore, private router : Router, private message: NzMessageService) {}

  indice : number = 0;
  $onDestroy: Subject<void> = new Subject<void>();
  Colaboradores: Colaborador[] = [];
  generarExcel: boolean = false;
  searchText: string = '';
  filteredColaboradores: Colaborador[] = [];
  user : Usuario | null = {};
  usuarioSeleccionado ?: number | null;
  loading : boolean = false;

  ngOnInit(): void {
    this.getUser()
  }

  getUser() {
    this.sessionStore
      .getPerfil()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((user:Usuario | null) => {
        this.user = user;
        if( this.user?.esAdmin || this.user?.esRRHH || this.user?.esColaborador || this.user?.esMedico ){
          this.obtenerInformacion();
        }
        else {
          this.$onDestroy.next();
          this.$onDestroy.complete();
          this.sessionStore.clearPerfil();
          this.router.navigate(['/']);
        }
      });
  }

  obtenerInformacion() {
    if(this.user?.esAdmin || this.user?.esRRHH){
      this.obtenerListaColaboradores();
    }
  }

  ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }

  onSearchChange(searchValue: string): void {
    this.searchText = searchValue.trim();
    
    if (!this.searchText) {
      this.filteredColaboradores = [...this.Colaboradores];
      return;
    }
    
    try {
      const regex = new RegExp(this.searchText, 'i');
      
      this.filteredColaboradores = this.Colaboradores.filter(colaborador => {
        const fullName = `${colaborador.nombres} ${colaborador.apellidos}`;
        const numeroEmpleado = colaborador.numeroEmpleado || '';
        
        return regex.test(numeroEmpleado) || regex.test(fullName);
      });
    } catch (error) {
      const searchLower = this.searchText.toLowerCase();
      this.filteredColaboradores = this.Colaboradores.filter(colaborador => {
        const fullName = `${colaborador.nombres} ${colaborador.apellidos}`.toLowerCase();
        const numeroEmpleado = (colaborador.numeroEmpleado || '').toLowerCase();
        
        return numeroEmpleado.includes(searchLower) || fullName.includes(searchLower);
      });
    }
  }

  onAccionClick(colaborador: Colaborador): void {
    this.usuarioSeleccionado = colaborador?.colaboradorId;
    this.indice = 1;
  }

  regresar(): void {
    this.indice = 0;
    this.usuarioSeleccionado = null;
  }

  obtenerListaColaboradores(): void {
    this.loading = true;
    this.homeService.obtenerListaColaboradores()
    .pipe(
      takeUntil(this.$onDestroy),
      finalize(() => {
        this.loading = false;
        this.cdr.detectChanges();
      })
    )
    .subscribe(
      {
        next: (res) => {
          let data = res?.details as Colaborador[];
          this.Colaboradores = data;
          this.filteredColaboradores = [...this.Colaboradores];
        },
        error: (error) => {
          console.error('Error al obtener la lista de colaboradores:', error);
        }
      }
    );
  }

    descargarExcel( ) {
      this.generarExcel = true;
      this.reportesService.generarExcelBeneficioNoEjecutado( null ).pipe(
        finalize(
          ()=>{
            this.generarExcel = false;
            this.cdr.detectChanges();
          }
        )
        )
        .subscribe({
          next: (res: any) => {
            try {
              if (res) {
                let blob: Blob;
                if (res instanceof Blob) {
                  blob = res;
                } else {
                  blob = new Blob([res], { 
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                  });
                }
                
                const fecha = new Date();
                const fechaString = fecha.toISOString().split('T')[0];
                const nombreArchivo = `${"Reporte Resumen de Gastos Medicos Menores y Comprobaciones"}_${fechaString}.xlsx`;            
                saveAs(blob, nombreArchivo);
              } else {
                console.error('La respuesta del servidor está vacía');
              }
            } catch (error) {
              console.error('Error al procesar la descarga del Excel:', error);
            }
          },
          error: (error:any) => {
            console.error('Error al generar Excel:', error);
          }
        });
      }

      visualizarInfo(){
        if(this.user!.colaboradorId) {
          this.usuarioSeleccionado = this.user!.colaboradorId;
          this.indice = 1;
        }
        else {
          this.message.error('No se encontró información del colaborador asociado al usuario.');
        }

      }
  
}
